import Tippy from '@tippyjs/react'

/**
 * Wraps children with a Tippy tooltip showing plain text on hover.
 *
 * @param {object} props
 * @param {import('react').ReactNode} props.text - Tooltip body content
 * @param {import('react').ReactNode} props.children - Trigger element
 * @param {string} [props.position] - Tippy placement (default `'top'`)
 * @param {string} [props.datatestid]
 * @param {string} [props.parentClassName]
 * @param {string} [props.className] - Class on tooltip content wrapper
 * @param {boolean} [props.truncate]
 */
const ToolTip = ({
  text,
  position = 'top',
  datatestid,
  parentClassName,
  children,
  className,
  truncate = true,
  ...props
}) => {
  return (
    <div data-testid="tooltip-wrapper" className={`inline-block ${parentClassName || ''}`}>
      <Tippy
        content={
          <div className={className || ''} data-testid="tooltip-content">
            {text}
          </div>
        }
        placement={position}
        data-testid={datatestid || 'tooltip'}
        allowHTML={true}
        {...props}
      >
        <span data-testid="tooltip-children" className={`block${truncate ? ' truncate' : ''}`}>
          {children}
        </span>
      </Tippy>
    </div>
  )
}

export default ToolTip
